export default __webpack_public_path__ + "static/media/brand-story-nidoru.c160c969.png";